// @flow
import type { ERROR_TYPE } from './common';
import type { STUDENT_TYPE } from './student';
import type { USER_TYPE } from './users';
import type { ROUTE_STOP_TYPE } from './routes';

export type CHANGE_STOP_REQUEST_TYPE = {
  id: number,
  from_stop: number,
  to_stop: number,
  dates: Array<Date>,
  requested_by: {
    id: number,
    first_name: string,
    last_name: string,
    profile_type: string
  },
  student: number,
  requested_at: string,
  dateRequested: string,
  dateApproved: string,
  instance_type: string,
  date_text: string,
  approved_by: USER_TYPE,
  description: string,
  state: string
};

export type CHANGE_STOP_REQUEST_FETCH_STARTED_TYPE = {
  type: 'CHANGE_STOP_REQUEST_FETCH_STARTED',
  payload: {
    schoolId: number,
    filters: {
      state: string,
      user: string,
      route_name: string,
      stop_name: string
    }
  }
};
export const CHANGE_STOP_REQUEST_FETCH_STARTED = 'CHANGE_STOP_REQUEST_FETCH_STARTED';

export type CHANGE_STOP_REQUEST_FETCH_FINISHED_TYPE = {
  type: 'CHANGE_STOP_REQUEST_FETCH_FINISHED',
  payload: {
    entities: Array<CHANGE_STOP_REQUEST_TYPE>,
    order: Array<number>,
    next?: number
  }
};

export const CHANGE_STOP_REQUEST_FETCH_FINISHED = 'CHANGE_STOP_REQUEST_FETCH_FINISHED';

export type CHANGE_STOP_REQUEST_FETCH_FAILED_TYPE = {
  type: 'CHANGE_STOP_REQUEST_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const CHANGE_STOP_REQUEST_FETCH_FAILED = 'CHANGE_STOP_REQUEST_FETCH_FAILED';

export type CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED_TYPE = {
  type: 'CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED',
  payload: {
    changeStopRequestId: number,
    state: string,
    instance_type: string,
    description: string,
  }
};
export const CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED = 'CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED';

export type CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS_TYPE = {
  type: 'CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS',
  payload: CHANGE_STOP_REQUEST_TYPE
};
export const CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS = 'CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS';

export type CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED_TYPE = {
  type: 'CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED',
  payload: ERROR_TYPE
};
export const CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED = 'CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED';

export type CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER_TYPE = {
  type: 'CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER',
  payload: string
};
export const CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER = 'CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER';

export type CHANGE_STOP_REQUEST_CREATE_STARTED_TYPE = {
    type: 'CHANGE_STOP_REQUEST_CREATE_STARTED',
    payload: CHANGE_STOP_REQUEST_TYPE
};
export const CHANGE_STOP_REQUEST_CREATE_STARTED = 'CHANGE_STOP_REQUEST_CREATE_STARTED';

export type CHANGE_STOP_REQUEST_CREATE_SUCCESS_TYPE = {
    type: 'CHANGE_STOP_REQUEST_CREATE_SUCCESS',
};
export const CHANGE_STOP_REQUEST_CREATE_SUCCESS = 'CHANGE_STOP_REQUEST_CREATE_SUCCESS';

export type CHANGE_STOP_REQUEST_CREATE_FAILED_TYPE = {
    type: 'CHANGE_STOP_REQUEST_CREATE_FAILED',
    payload: ERROR_TYPE
};
export const CHANGE_STOP_REQUEST_CREATE_FAILED = 'CHANGE_STOP_REQUEST_CREATE_FAILED';

export type FETCH_CHANGE_STOP_REQUEST_COUNTER_TYPE = {
  type: 'FETCH_CHANGE_STOP_REQUEST_COUNTER',
};
export const FETCH_CHANGE_STOP_REQUEST_COUNTER = 'FETCH_CHANGE_STOP_REQUEST_COUNTER';

export type FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED_TYPE = {
  type: 'FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED',
  payload: number,
};
export const FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED = 'FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED';


export type CHANGE_STOP_REQUEST_ACTION_TYPE =
  | CHANGE_STOP_REQUEST_FETCH_FAILED_TYPE
  | CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED_TYPE
  | CHANGE_STOP_REQUEST_CREATE_STARTED_TYPE
  | CHANGE_STOP_REQUEST_CREATE_SUCCESS_TYPE
  | CHANGE_STOP_REQUEST_CREATE_FAILED_TYPE
  | CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER_TYPE
  | CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS_TYPE
  | CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED_TYPE
  | CHANGE_STOP_REQUEST_FETCH_FINISHED_TYPE
  | FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED_TYPE
  | FETCH_CHANGE_STOP_REQUEST_COUNTER_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/changeStopRequest.js